import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => {
  return {
    fields: {
      // we're controling the grid's row spacing
      // because HvGrid still doesn't support it to
      // be different from the column spacing.
      "$root&>div": {
        paddingTop: 5,
        paddingBottom: 0,
      },
    },
    row: {
      display: "flex",
      alignItems: "end",
    },
    datePicker: {
      width: "55%",
    },
    timePicker: {
      width: "40%",
      marginLeft: "auto",
    },
    gridHeight: {
      height: "86px",
      padding: "0 15px",
    },
    gridPadding: {
      padding: "0px 15px 32px 15px",
    },
    gridHeightAuto: {
      height: "auto",
      paddingBottom: "32px",
    },
  };
});
